var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.173 13c.062 0 .13-.01.203-.031a.525.525 0 0 0 .36-.532V6.289l3.877-4.083c.188-.188.308-.407.36-.657.052-.261.029-.514-.07-.759a1.21 1.21 0 0 0-.477-.579 1.303 1.303 0 0 0-.72-.211H1.294c-.26 0-.5.07-.719.211A1.21 1.21 0 0 0 .097.79a1.34 1.34 0 0 0 .274 1.416L4.64 6.32v4.099c0 .156.057.287.172.39l1.954 2.019c.104.115.24.172.407.172zm-.563-1.909-.845-.907V6.085a.53.53 0 0 0-.156-.39L1.17 1.407c-.053-.052-.063-.112-.032-.18a.16.16 0 0 1 .156-.102h9.414c.072 0 .122.034.148.102a.157.157 0 0 1-.039.18l-4.05 4.255a.53.53 0 0 0-.156.391v5.037z",
    fill: "#F6B119",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.3e2ae904fcda6e66914e97c3e33e9c26.svg";
export { ForwardRef as ReactComponent };